module.exports = __webpack_public_path__ + "static/media/primary-full-colour.915624a9.png";